var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortSelectArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#151B26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 14.75C9.70158 14.75 9.40292 14.636 9.17519 14.4085L2.00889 7.242C1.55302 6.78613 1.55302 6.04702 2.00889 5.59133C2.46458 5.13565 3.20354 5.13565 3.65945 5.59133L10.0002 11.9325L16.3411 5.59177C16.7968 5.13609 17.5359 5.13609 17.9916 5.59177C18.4476 6.04746 18.4476 6.78635 17.9916 7.24222L10.8254 14.4087C10.5975 14.6362 10.2989 14.75 10.0002 14.75Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortSelectArrowDown);
export default ForwardRef;